const service_date_delays = [
  { label: "0 minut", value: 0 },
  { label: "30 minut (0.5h)", value: 30 },
  { label: "60 minut (1h)", value: 60 },
  { label: "120 minut (2h)", value: 120 },
  { label: "240 minut (4h)", value: 240 },
];

export default service_date_delays;
